import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RomaneioService } from '../service/romaneio.service';
import { PoBreadcrumb, PoModalAction, PoPageFilter, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { RelatorioInconsistenciasItem } from '../interface/romaneio';

@Component({
  selector: 'app-relatorio-inconsistencias',
  templateUrl: './relatorio-inconsistencias.component.html',
  styleUrls: ['./relatorio-inconsistencias.component.css']
})
export class RelatorioInconsistenciasComponent implements OnInit {

  tabelaPrincipalItens: Array<RelatorioInconsistenciasItem> = [];

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
  ) {
  }

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  tabelaPrincipalLoad(): void {

    this.romaneioService.listaRelatorioInconsistencias().subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items;
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CTIPO'          , label: 'Tipo'         , width: '15%', type: 'label',
      labels: [
        { value: '1', color: 'color-01', label: 'Pedido excluído' },
      ]
    },
    {property: 'CZ02LOTE'       , label: 'Lote'       , width: '15%'},
    {property: 'CZ02PEDIDO'     , label: 'Pedido'     , width: '10%'},
    {property: 'CZ02COD'        , label: 'Código'     , width: '15%'},
    {property: 'CZ02PRAT'       , label: 'Prateleria' , width: '15%'},
    {property: 'CZ02UR'         , label: 'UR'         , width: '10%'},
    {property: 'CZ02INFORM'     , label: 'T ou E'     , width: '15%', type: 'label',
      labels: [
        { value: 'T', color: 'color-01',  label: 'Toco'     },
        { value: 'E', color: 'color-05',  label: 'Esqui'    },
      ]
    },
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', action: this.goHome.bind(this) },
      { label: 'Relatório Inconsistências' }
    ]
  };

  goHome(): void {
    this.router.navigateByUrl('');
  }

}
